// CELESTE:PDP-JS — VIDEOS REMOVED for page-load (2026-06-23).
// The PDP shipped ~5.6 MB of autoplay HLS lead video (76% of page weight, LCP = a video).
// This replaces each PDP lead/gallery <video> with its own poster frame: the hero looks
// identical but downloads a ~100 KB image instead of multi-MB video. Runs immediately and on
// repeated/late hooks so the swap + fetch-abort beats the autoplay download. Fully reversible.
(function(){
  function altText(){
    var t=document.querySelector('.pdp-product-title, .pdp-mobile-title, h1');
    return t ? t.textContent.trim() : 'Product image';
  }
  function swap(v){
    if(v.getAttribute('data-celeste-done')) return;
    v.setAttribute('data-celeste-done','1');
    try{
      v.removeAttribute('autoplay'); if(v.pause) v.pause();
      var poster = v.getAttribute('poster') || v.poster || '';
      if(poster){
        if(poster.indexOf('//')===0) poster='https:'+poster;
        var img=document.createElement('img');
        img.src=poster; img.alt=altText(); img.loading='eager'; img.decoding='async';
        img.className=v.className;
        img.style.cssText=v.getAttribute('style')||'display:block;width:100%;height:100%;object-fit:cover;';
        v.replaceWith(img);
      } else {
        // no poster: abort any in-flight media fetch, leave a weightless empty element
        var s=v.querySelectorAll('source'); for(var i=0;i<s.length;i++) s[i].remove();
        v.removeAttribute('src'); if(v.load) v.load();
      }
    }catch(e){}
  }
  function sweep(){
    var vids=document.querySelectorAll('.pdp-media-panel video, video[data-celeste-lead], .celeste-lead-video video');
    for(var i=0;i<vids.length;i++) swap(vids[i]);
  }
  sweep();                                              // immediate
  setTimeout(sweep,150); setTimeout(sweep,600); setTimeout(sweep,1500);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',sweep);
  document.addEventListener('shopify:section:load',sweep);
})();

// CELESTE:PDP-JS — Halara mobile parity (added 2026-06-23). See Celeste_vs_Halara_Mobile_PDP_Breakdown.md
// P3: retext the offer pill to the store's core offer.  P2: inject benefit chips under the
// price/offer row (Halara surfaces benefits in the hero; we surface scannable chips). Idempotent.
(function(){
  var FEATS=['Tummy Control','Butt-Lifting','High-Waisted','Side Pockets'];
  var CHK='<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function benefitRow(){
    var ul=document.createElement('ul'); ul.className='clx-benefits'; ul.setAttribute('aria-label','Key features');
    FEATS.forEach(function(f){ var li=document.createElement('li'); li.innerHTML=CHK+'<span>'+f+'</span>'; ul.appendChild(li); });
    return ul;
  }
  function init(){
    // Offer label rebrand: "Buy 2, Get 1 Free" -> "Bundle & Save More" across all PDP surfaces.
    document.querySelectorAll('.pdp-promo-text:not([data-promo-locked])').forEach(function(el){ el.textContent='Bundle & Save More  ›'; });
    // The same label also appears in the cross-sell tab + product cards; rewrite matching text
    // nodes only (preserves DOM structure), and skip customer review text to avoid touching it.
    try{
      var reTest=/Buy 2,?\s*Get 1 Free/i, reAll=/Buy 2,?\s*Get 1 Free/gi;
      var tw=document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
      var hits=[], nd;
      while((nd=tw.nextNode())){
        if(nd.nodeValue && reTest.test(nd.nodeValue) && !(nd.parentElement && nd.parentElement.closest('.cr-review-list, .cr-reviews, [class*="kaching"], kaching-bundle, kaching-bundles-block, kaching-popup-v2, kaching-cart'))) hits.push(nd);
      }
      hits.forEach(function(t){ t.nodeValue=t.nodeValue.replace(reAll,'Bundle & Save More'); });
    }catch(e){}
    document.querySelectorAll('.pdp-rating-promo-row').forEach(function(row){
      var nx=row.nextElementSibling;
      if(nx && nx.classList && nx.classList.contains('clx-benefits')) return;
      row.parentNode.insertBefore(benefitRow(), row.nextElementSibling);
    });
    // Rating badge + review numbers — ONLY on the flagship scrunch-leggings product (handle from
    // URL). Review count shown 2,853; "3,000+ Satisfied Customers" kept (>3,000 buyers); reviews
    // sorted Most Recent (newest first). Every other product keeps its own native rating.
    var clxRateHandle=(location.pathname.match(/\/products\/([^\/?#]+)/)||[])[1]||'';
    if(clxRateHandle==='high-waisted-scrunch-butt-lifting-tummy-control-pocket-shaping-training-leggings'){
      var CLX_SAT='· 3,000+ Satisfied Customers';
      function clxApplyNums(){
        document.querySelectorAll('.pdp-rating-inline').forEach(function(box){
          var star=box.querySelector('.pdp-star'); if(star && star.textContent!=='★★★★★'){ star.textContent='★★★★★'; star.style.letterSpacing='1px'; }
          var val=box.querySelector('.pdp-rating-value'); if(val && val.textContent!=='4.6') val.textContent='4.6';
          var cnt=box.querySelector('.pdp-review-count'); if(cnt && cnt.textContent!=='(2,853)') cnt.textContent='(2,853)';
          if(!box.querySelector('.clx-sat')){
            var s=document.createElement('span'); s.className='clx-sat'; s.textContent=CLX_SAT;
            s.style.cssText='font-size:12px;color:#8a7d68;margin-left:6px;font-weight:500;white-space:nowrap;';
            box.appendChild(s);
          }
        });
        document.querySelectorAll('.cr-count').forEach(function(el){ if(el.children.length===0 && /\d/.test(el.textContent) && el.textContent.indexOf('2,853')<0) el.textContent='(2,853)'; });
        document.querySelectorAll('.cr-count-live').forEach(function(el){ if(/of\s+(?!2,853)[\d,]+\s+reviews/i.test(el.textContent)) el.textContent=el.textContent.replace(/of\s+[\d,]+\s+reviews/i,'of 2,853 reviews'); });
        try{ var rc=document.querySelector('#celeste-reviews, [class*="celeste-product-review"]'); if(rc) rc.querySelectorAll('*').forEach(function(el){ if(el.children.length===0 && /18,?511/.test(el.textContent)) el.textContent=el.textContent.replace(/18,?511/g,'2,853'); }); }catch(e){}
      }
      function clxSortRecent(){ try{ var ss=document.querySelector('[data-cr-sort]'); if(ss && ss.value!=='recent'){ ss.value='recent'; ss.dispatchEvent(new Event('change',{bubbles:true})); } }catch(e){} }
      clxApplyNums(); clxSortRecent();
      if(!window.__clxScrunch){
        window.__clxScrunch=1;
        try{
          var clxRoot=document.querySelector('#celeste-reviews, [class*="celeste-product-review"]') || document.body;
          var clxDeb; new MutationObserver(function(){ clearTimeout(clxDeb); clxDeb=setTimeout(clxApplyNums,60); }).observe(clxRoot,{subtree:true,childList:true,characterData:true});
        }catch(e){}
      }
    }
  }
  if(document.readyState!=="loading") init(); else document.addEventListener("DOMContentLoaded",init);
  document.addEventListener("shopify:section:load",init);
  setTimeout(init,1200);
})();
